import { memo, useContext } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { BrandLoadingContext, BrandStateContext } from '@/containers/Workspace.Brand/Context';
import styles from '@/screens/Workspace.File/style/Header.Actions.module.css';
import { Access } from './Header.Access';
import { DiscoverInsights } from '@trinity/chat-components/components/DiscoverInsights/DiscoverInsights.js';

type Props = unknown;

export const Actions = (props: Props) => {
  const isLoading = useContext(BrandLoadingContext);

  return isLoading
    ? <SkeletonActions />
    : <InteractiveActions />;
};

Actions.displayName = 'Brand.Header.Actions';

const InteractiveActions = (props: Props) => {
  return (
    <div className={styles.root}>
      <DiscoverInsights className={styles.discover} />
      <Access />
    </div>
  );
};

InteractiveActions.displayName = 'Brand.Header.Actions.Interactive';

const SkeletonActions = memo((props: Props) => {
  return (
    <div className={styles.actions}>
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
    </div>
  );
});

SkeletonActions.displayName = 'Brand.Header.Actions.Skeleton';